import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DownloadIcon from '../../../assets/icons/download-cloud-02.svg';
import Button from '../../../components/Button/Button';
import { PATHNAME } from '../../../pathname';
import CustomPagination from '../../../components/Common/CustomPagination/CustomPagination';
import { getAllUnits, getRegionUnitAnticipatedOrderListing } from '../../../redux/unitSlice/unitSlice';
import CustomSelectWithFilter from '../../../components/Common/CustomSelect/CustomSelectWithFilter';
import { exportExcel } from '../../../redux/adminUnitReportSlice/adminUnitReportSlice';
import CustomTable from '../../../components/Common/CustomTable/CustomTable';
import { getRegionUnitOtherProjectsListing, getOtherProjectsDate } from '../../../redux/otherProjectsSlice/otherProjectsSlice';
import SearchBar from '../../../components/Common/SearchBar/SearchBar';
import { fetchOtherProjectDataFilledStatus } from '../../../redux/projectsSlice/projectSlice';
import DataFilledStatusTable from '../ActiveProjects/DataSubmissionStatus/Tables/DataFilledStatusTable';
// import DataFilledStatusTable from './Tables/DataFilledStatusTable';
import FileCheckIcon from '../../../assets/icons/file-check-03.svg';
import { DatePicker, Table } from 'antd';
import { format } from 'date-fns';
import dayjs from "dayjs";

const AdminOtherProjects = () => {
        const navigate = useNavigate();
        const dispatch = useDispatch();
        const [searchParams] = useSearchParams();
        const searchFromUrl = searchParams.get('search') || '';

        const [currentPage, setCurrentPage] = useState(1);
        const [value, setValue] = useState("");
        const [searchValue, setSearchValue] = useState(searchFromUrl);
        const pageSize = 100000; // Items per page
        const { RangePicker } = DatePicker;
        const { allUnitsList } = useSelector((state) => state.unit);
        const { otherProjectListing, otherProjectListingTotal, otherProjectTotals, loading, systemDate } = useSelector((state) => state.otherProjects);
        // const { otherProjectStatus } = useSelector((state) => state.project);
        const getCurrentFYRange = () => {
                const currentYear = new Date().getFullYear();
                const currentMonth = new Date().getMonth() + 1;

                const fyStartYear = currentMonth >= 4 ? currentYear : currentYear - 1;

                return {
                        fromDate: dayjs(`${fyStartYear}-04-01`),
                        toDate: dayjs(`${fyStartYear + 1}-03-01`),
                };
        };

        const { fromDate, toDate } = getCurrentFYRange();

        const [selectedDateRange, setSelectedDateRange] = useState([
                fromDate,
                toDate,
        ]);
        const [monthRange, setMonthRange] = useState({
                from_date: `01-04-${fromDate.year()}`,
                to_date: `01-03-${toDate.year()}`,
        });
        const prevYearShort = String(new Date().getFullYear() - 1).slice(-2);
        const handleMonthRangeChange = (dates) => {
                setSelectedDateRange(dates);
                if (dates && dates.length === 2) {
                        const fromDate = dates[0].toDate();
                        const toDate = dates[1].toDate();

                        setMonthRange({
                                from_date: format(fromDate, '01-MM-yyyy'),
                                to_date: format(toDate, '01-MM-yyyy'),
                        });
                } else {
                        setMonthRange({
                                from_date: null,
                                to_date: null,
                        });
                }
        };
        const totalRow = {
                key: "TOTAL",
                PROJECT_TITLE: "TOTAL",
                IO_NO: "",
                REVISED_ORDER_VALUE: otherProjectTotals?.REVISED_ORDER_VALUE,
                BALANCE_REVENUE_RECOGNISED: otherProjectTotals?.BALANCE_REVENUE_RECOGNISED,
                REVENUE: otherProjectTotals?.REVENUE,
                PROJECT_COST: otherProjectTotals?.PROJECT_COST,
                DM_PERCENT: `${otherProjectTotals?.DM_PERCENT}%`,
                PROFIT_LOSS: otherProjectTotals?.PROFIT_LOSS,
                APPORTIONED_COST: otherProjectTotals?.APPORTIONED_COST,
                TOTAL_OPERATIONAL_INCOME: otherProjectTotals?.TOTAL_OPERATIONAL_INCOME,
                TOTAL_NET_BILLING: otherProjectTotals?.TOTAL_NET_BILLING,
                TOTAL_CASH_INFLOW: otherProjectTotals?.TOTAL_CASH_INFLOW,
                TOTAL_CASH_OUTFLOW: otherProjectTotals?.TOTAL_CASH_OUTFLOW,
                NET_CASH_FLOW: otherProjectTotals?.NET_CASH_FLOW,
                isGrandTotal: true,
        };

        const finalData = [totalRow, ...(otherProjectListing || [])];

        const totals = Array.isArray(otherProjectListing)
                ? otherProjectListing.reduce(
                        (acc, item) => {
                                const parse = (v) => Number(String(v || 0).replace(/,/g, ""));

                                acc.REVENUE += parse(item.REVENUE);
                                acc.PROJECT_COST += parse(item.PROJECT_COST);
                                acc.APPORTIONED_COST += parse(item.APPORTIONED_COST);
                                acc.TOTAL_OPERATIONAL_INCOME += parse(item.TOTAL_OPERATIONAL_INCOME);
                                acc.PROFIT_LOSS += parse(item.PROFIT_LOSS);
                                acc.TOTAL_NET_BILLING += parse(item.TOTAL_NET_BILLING);
                                acc.TOTAL_CASH_INFLOW += parse(item.TOTAL_CASH_INFLOW);
                                acc.TOTAL_CASH_OUTFLOW += parse(item.TOTAL_CASH_OUTFLOW);
                                acc.NET_CASH_FLOW += parse(item.NET_CASH_FLOW);
                                acc.REVISED_ORDER_VALUE += parse(item.REVISED_ORDER_VALUE);
                                acc.BALANCE_REVENUE_RECOGNISED += parse(item.BALANCE_REVENUE_RECOGNISED);

                                return acc;
                        },
                        {
                                REVENUE: 0,
                                PROJECT_COST: 0,
                                APPORTIONED_COST: 0,
                                TOTAL_OPERATIONAL_INCOME: 0,
                                PROFIT_LOSS: 0,
                                TOTAL_NET_BILLING: 0,
                                TOTAL_CASH_INFLOW: 0,
                                TOTAL_CASH_OUTFLOW: 0,
                                NET_CASH_FLOW: 0,
                                REVISED_ORDER_VALUE: 0,
                                BALANCE_REVENUE_RECOGNISED: 0,
                        }
                )
                : {
                        REVENUE: 0,
                        PROJECT_COST: 0,
                        APPORTIONED_COST: 0,
                        TOTAL_OPERATIONAL_INCOME: 0,
                        PROFIT_LOSS: 0,
                        TOTAL_NET_BILLING: 0,
                        TOTAL_CASH_INFLOW: 0,
                        TOTAL_CASH_OUTFLOW: 0,
                        NET_CASH_FLOW: 0,
                        REVISED_ORDER_VALUE: 0,
                        BALANCE_REVENUE_RECOGNISED: 0,
                };
        const formatNumber = (num) => (num || 0).toLocaleString("en-IN");
        const unitRegionColumns = [
                // {
                //         title: 'Project Name',
                //         dataIndex: 'PROJECT_TITLE',
                //         key: 'PROJECT_TITLE',
                //         align: 'center',
                //         fixed: 'left',
                //         width: 300,

                //         render: (text, record) => (

                //                 <a
                //                         className="text-blue-500 underline cursor-pointer text-right"
                //                         onClick={() => navigate(`${PATHNAME.ADMIN_OTHER_PROJECTS_DETAILS}/${encodeURIComponent(text)}/?ioNo=${record.IO_NO}&revNo=${record.REV_NO}`)}>
                //                         {text || '--'}
                //                 </a>
                //         ),
                // },
                {
                        title: 'Project Name',
                        dataIndex: 'PROJECT_TITLE',
                        key: 'PROJECT_TITLE',
                        align: 'center',
                        fixed: 'left',
                        width: 300,

                        render: (text, record) => {
                                if (record.isGrandTotal) {
                                        return <span className="font-semibold">{text}</span>;
                                }
                                return (
                                        <a
                                                className="text-blue-500 underline cursor-pointer text-right"
                                                onClick={() =>
                                                        navigate(
                                                                `${PATHNAME.ADMIN_OTHER_PROJECTS_DETAILS}/${encodeURIComponent(text)}/?ioNo=${record.IO_NO}&revNo=${record.REV_NO}`
                                                        )
                                                }
                                        >
                                                {text || '--'}
                                        </a>
                                );
                        },
                },
                {
                        title: 'Io No',
                        dataIndex: 'IO_NO',
                        key: 'IO_NO',
                        align: 'center',
                        fixed: 'left',
                        width: 200,

                        render: (text) => <span className="text-center">{`${text}`}</span>,
                },
                {
                        title: 'TCR',
                        dataIndex: 'REVISED_ORDER_VALUE',
                        key: 'REVISED_ORDER_VALUE',
                        width: 200,
                        align: 'center',
                        render: (text) => <div className=" text-right">{text || '--'}</div>
                },
                {
                        title: systemDate?.STARTDATE ? `Order O/S as on ${systemDate.STARTDATE}` : `Order O/S upto Dec ${prevYearShort}`,
                        dataIndex: 'BALANCE_REVENUE_RECOGNISED',
                        key: 'BALANCE_REVENUE_RECOGNISED',
                        width: 180,
                        align: 'center',
                        render: (text) => <div className=" text-right">{text || '--'}</div>
                },
                {
                        title: 'Revenue',
                        dataIndex: 'REVENUE',
                        key: 'REVENUE',
                        align: 'center',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Project Cost',
                        dataIndex: 'PROJECT_COST',
                        key: 'PROJECT_COST',
                        align: 'center',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'DM%',
                        dataIndex: 'DM_PERCENT',
                        key: 'DM_PERCENT',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        // title: 'Profit/Loss',
                        title: 'Margin',
                        dataIndex: 'PROFIT_LOSS',
                        key: 'PROFIT_LOSS',
                        width: 150,

                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },
                {
                        title: 'Other Apportioned Cost',
                        dataIndex: 'APPORTIONED_COST',
                        key: 'APPORTIONED_COST',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Other Operational Income',
                        dataIndex: 'TOTAL_OPERATIONAL_INCOME',
                        key: 'TOTAL_OPERATIONAL_INCOME',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Net Billing',
                        dataIndex: 'TOTAL_NET_BILLING',
                        key: 'TOTAL_NET_BILLING',
                        width: 150,

                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },
                {
                        title: 'Cash Inflow',
                        dataIndex: 'TOTAL_CASH_INFLOW',
                        key: 'TOTAL_CASH_INFLOW',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Cash Outflow',
                        dataIndex: 'TOTAL_CASH_OUTFLOW',
                        key: 'TOTAL_CASH_OUTFLOW',
                        width: 150,

                        render: (text) => {
                                return <div className="text-right">{text ?? '--'}</div>;
                        },
                },
                {
                        title: 'Net Cashflow',
                        dataIndex: 'NET_CASH_FLOW',
                        key: 'NET_CASH_FLOW',
                        width: 150,

                        render: (text) => {
                                const value = text && Number(text.split(',').join(''));
                                const color = value < 0 ? 'text-red-500' : 'text-green-500';
                                return <div className={`text-right ${color} text-[14px]`}>{text || '--'}</div>;
                        },
                },

        ];

        useEffect(() => {
                dispatch(
                        getRegionUnitOtherProjectsListing({
                                page: currentPage,
                                limit: pageSize,
                                search: searchValue,
                                mnfUnits: value, // Changed from MNF_UNIT to mnfUnits to match API action
                                monthRange: monthRange, // Pass monthRange to the action
                        }),
                );
                // dispatch(fetchOtherProjectDataFilledStatus());

        }, [currentPage, searchValue, monthRange, value]);

        useEffect(() => {
                dispatch(getAllUnits());
                dispatch(getOtherProjectsDate("system"));
        }, [dispatch]);

        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-8">
                                <div className="flex justify-between">
                                        <div className="font-inter font-semibold text-[24px] leading-[32px] tracking-[0%] text-[#101828]">Other Projects</div>
                                        <div> <Button type="primary"
                                                icon={FileCheckIcon}
                                                onClick={() => navigate('/projects-other-projects/data-submission-status')} text="Data Submission Listing" ></Button></div>
                                </div>
                                <div className="text-gray-500 text-sm flex justify-start">* All figures are in Rupees (in Crores).</div>
                                <div className="flex justify-between ">
                                        <div>
                                                <SearchBar
                                                        onSearch={setSearchValue}
                                                        defaultValue={searchFromUrl}
                                                        className="!w-[330px]"
                                                />
                                        </div>

                                        <div className="flex gap-3">
                                                <RangePicker
                                                        picker="month"
                                                        format="MMMM YYYY"
                                                        onChange={handleMonthRangeChange}
                                                        value={selectedDateRange}
                                                        placeholder={['From Month', 'To Month']}
                                                        allowClear
                                                        className='h-10'
                                                />
                                                <CustomSelectWithFilter
                                                        showSearch="true"
                                                        data={
                                                                Array.isArray(allUnitsList)
                                                                        ? allUnitsList.map((value) => ({
                                                                                label: value?.UNIT_DISPLAY_NAME,
                                                                                value: value?.MNF_UNIT,
                                                                        }))
                                                                        : []
                                                        }
                                                        onChange={(value) => {
                                                                setValue(value);
                                                        }}
                                                        placeholder="Select Unit/Region"
                                                        className="w-[15rem]"
                                                />
                                                <Button
                                                        text="Export report"
                                                        icon={DownloadIcon}
                                                        onClick={() =>
                                                                dispatch(
                                                                        exportExcel({
                                                                                key: 'admin_other_projects_list',
                                                                                params: {
                                                                                        MNF_UNIT: value,
                                                                                        search: searchValue,
                                                                                        from_date: monthRange?.from_date,
                                                                                        to_date: monthRange?.to_date,
                                                                                },
                                                                        }),
                                                                )
                                                        }
                                                />
                                        </div>
                                </div>
                        </div>
                        <div className="px-5 flex flex-col gap-6 pt-8">
                                <CustomTable
                                        dataSource={finalData}
                                        columns={unitRegionColumns}
                                        loading={loading}
                                // summary={() => (
                                //         <Table.Summary fixed="top" className="bg-[#cce6ff]">
                                //                 <Table.Summary.Row className="bg-blue-100 font-semibold text-[16px]">

                                //                         <Table.Summary.Cell index={0}>TOTAL</Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={1}></Table.Summary.Cell> {/* IO No */}

                                //                         {/* ✅ TCR */}
                                //                         <Table.Summary.Cell index={2} className="text-right">
                                //                                 {formatNumber(totals?.REVISED_ORDER_VALUE)}
                                //                         </Table.Summary.Cell>

                                //                         {/* ✅ Order O/S */}
                                //                         <Table.Summary.Cell index={3} className="text-right">
                                //                                 {formatNumber(totals?.BALANCE_REVENUE_RECOGNISED)}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={4} className="text-right">
                                //                                 {totals.REVENUE.toLocaleString("en-IN")}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={5} className="text-right">
                                //                                 {totals.PROJECT_COST.toLocaleString("en-IN")}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={6}></Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={7} className="text-right">
                                //                                 {totals.PROFIT_LOSS.toLocaleString("en-IN")}
                                //                                 {/* {totals.APPORTIONED_COST.toLocaleString("en-IN")} */}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={8} className="text-right">
                                //                                 {totals.APPORTIONED_COST.toLocaleString("en-IN")}
                                //                                 {/* {totals.TOTAL_OPERATIONAL_INCOME.toLocaleString("en-IN")} */}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={9} className="text-right">
                                //                                 {totals.TOTAL_OPERATIONAL_INCOME.toLocaleString("en-IN")}
                                //                                 {/* {totals.PROFIT_LOSS.toLocaleString("en-IN")} */}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={10} className="text-right">
                                //                                 {totals.TOTAL_NET_BILLING.toLocaleString("en-IN")}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={11} className="text-right">
                                //                                 {totals.TOTAL_CASH_INFLOW.toLocaleString("en-IN")}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={12} className="text-right">
                                //                                 {totals.TOTAL_CASH_OUTFLOW.toLocaleString("en-IN")}
                                //                         </Table.Summary.Cell>

                                //                         <Table.Summary.Cell index={13} className="text-right">
                                //                                 {totals.NET_CASH_FLOW.toLocaleString("en-IN")}
                                //                         </Table.Summary.Cell>

                                //                 </Table.Summary.Row>
                                //         </Table.Summary>
                                // )}
                                />
                                <div>
                                        <CustomPagination
                                                totalItems={otherProjectListingTotal}
                                                pageSize={pageSize}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                        />
                                </div>

                        </div>
                </div>
        );
};

export default AdminOtherProjects;
